import { isBrowser } from '@/utils/env';
import { optAppConfig } from '@/utils/config';

export function gtag(...args: any[]): void {
  if (!isBrowser()) {
    return;
  }
  // @ts-expect-error -- Google made me do it!
  window.gtag(...args);
}

export function isGoogleAnalyticsEnabled(): boolean {
  return !!optAppConfig((_) => _.google_analytics.is_enabled);
}
